import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
// import Select from 'react-select';
import _ from 'lodash';
import queryString from 'query-string';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
// import moment from 'moment';
import { numberWithCommas } from 'helper';
import moment from 'moment';
import * as actions from '../actions';
import * as c from '../constants';
import history from '../../../../history';

const AmnestyReports = ({ getAmnestyList, list, isLoading, pager }) => {
  const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const [formData, setFormData] = useState({
    bin: '',
    q: '',
    date_from: '',
    date_to: '',
  });
  const [date, setDate] = useState({ date_from: '', date_to: '' });
  const syncFilters = (params) => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleChangePage = (page) => {
    getAmnestyList({
      ...formData,
      ...date,
      page,
    });
    syncFilters({ ...formData, page });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    syncFilters({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    getAmnestyList({
      ...formData,
    });
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    getAmnestyList({
      ...formData,
      date_from: _.get(formData, 'date_from')
        ? `${moment(_.get(formData, 'date_from')).format(
            'YYYY-MM-DD HH:mm'
          )}:00`
        : '',
      date_to: _.get(formData, 'date_to')
        ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')} 23:59:00`
        : '',
    });

    setDate({
      date_from: _.get(formData, 'date_from')
        ? `${moment(_.get(formData, 'date_from')).format(
            'YYYY-MM-DD HH:mm'
          )}:00`
        : '',
      date_to: _.get(formData, 'date_to')
        ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')} 23:59:00`
        : '',
    });
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      bin: '',
      q: '',
      date_from: '',
      date_to: '',
    });
    setDate({ date_from: '', date_to: '' });
    syncFilters({
      bin: '',
      q: '',
      date_from: '',
      date_to: '',
    });
    getAmnestyList({});
    history.replace({ pathname: window.location.pathname });
  };

  const getAmnestyReports = () => {
    const path = `${process.env.REACT_APP_WS}api/v1/bpls/administrator/report/tax_amnesty/export`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...date,
      bearer_token: token,
      email: _.get(authProfile, 'email'),
    });
    return `${path}?${params}`;
  };

  const renderAmount = (value) => {
    return value ? (
      <>
        <b className="d-inline">PHP&nbsp;</b>{' '}
        <inline>{numberWithCommas(+value?.toFixed(2))}</inline>
      </>
    ) : (
      '---'
    );
  };

  return (
    <div className="module-inner">
      <div className="report-module-nav mb-3">
        <div className="col-12">
          <form onSubmit={onSearch}>
            <div className="row mt-2">
              <div className="col-3 pr-0">
                <div className="form-group">
                  <label className="label-reports">BIN</label>
                  <input
                    className="form-control"
                    name="bin"
                    onChange={onChange}
                    value={query.bin || ''}
                  />
                </div>
              </div>
              <div className="col-3 pr-0">
                <div className="form-group">
                  <label className="label-reports">Business Name</label>
                  <input
                    className="form-control"
                    name="q"
                    onChange={onChange}
                    value={query.q || ''}
                  />
                </div>
              </div>
              <div className="form-input-group col-3">
                <label className="label-reports">Date From</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleDateChange('date_from')}
                  value={_.get(formData, 'date_from') || ''}
                />
              </div>
              <div className="form-input-group col-3">
                <label className="label-reports">Date To</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleDateChange('date_to')}
                  value={_.get(formData, 'date_to') || ''}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-6 pr-0">
                <div className="form-group">
                  <button
                    onClick={onClear}
                    type="button"
                    className="btn btn-link button-black py-2"
                  >
                    <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                  </button>
                  &nbsp;
                  <button
                    type="submit"
                    className="btn btn-md btn-primary cms-bg-color-primary mt-0 py-2"
                  >
                    <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
                  </button>
                </div>
              </div>
              <div className="col-6 pr-0 d-flex ml-auto pr-3">
                <div className="ml-auto">
                  <div className="">
                    <a
                      href={getAmnestyReports()}
                      className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary "
                      style={{ color: 'white' }}
                    >
                      <i className="fas fa-cloud-download-alt mr-2" />
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="row pr-3 py-2 mb-2">
            <div className="ml-3">
              <div className="form-group">
                <label className="label-reports">
                  Total Registered: &nbsp;
                </label>
                <input name="q" disabled value={_.get(pager, 'total') || ''} />
              </div>
            </div>
          </div>
          {isLoading ? (
            <div
              className="loading d-flex text-center justify-content-center align-items-center"
              style={{ height: '500px' }}
            >
              <div className="spinner text-center ">
                <span className="fas fa-5x fa-spin fa-spinner" />
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered table-hover">
                <thead className="table-header text-center">
                  <tr>
                    <th>BIN</th>
                    <th>Business Name</th>
                    <th>Tax Year</th>
                    <th>Gross Amount</th>
                    <th>Amnesty Amount</th>
                    <th>Net Amount</th>
                  </tr>
                </thead>
                <tbody className="table-details">
                  {list.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{_.get(item, 'attributes.bin') || '---'}</td>
                        <td className="text-capitalize">
                          {_.get(
                            item,
                            'attributes.business_name'
                          )?.toLowerCase() || '---'}
                        </td>
                        <td>{_.get(item, 'attributes.year') || '---'}</td>
                        <td>
                          {renderAmount(
                            +_.get(item, 'attributes.gross_amount')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            +_.get(item, 'attributes.amnesty_amount')
                          )}
                        </td>
                        <td>
                          {renderAmount(+_.get(item, 'attributes.net_amount'))}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          <div className="list-pagination">
            {pager.total_pages > 1 ? (
              <div className="d-flex justify-content-center text-center align-item-center">
                <Pagination data={pager} onChange={handleChangePage} />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

AmnestyReports.propTypes = {
  getAmnestyList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.AMNESTY_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.AMNESTY_LIST) > -1,
  pager: _.get(api, `${c.AMNESTY_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AmnestyReports);
